import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import default_config from '../default_config';
import { Locale } from './locale';

interface StateAllAuth {
  apiBaseUrl: string;
  kratosUrl: string;
  audience: string;
  applicationUri: string;
  userManagementUrl?: string;
}

export interface ConfigState {
  loaded: boolean;
  error?: Error;
  baseUrl: string;
  attachmentUrl: string;
  allauth: StateAllAuth;
  noHookApiCalls: boolean;
  locale: Locale;
  policeReportUrl: string;
  mapDefaultCenter: { lat: number; lng: number };
}

export interface PartialState extends Partial<Omit<ConfigState, 'allauth'>> {
  allauth?: Partial<StateAllAuth>;
}

export function mergeState(a: ConfigState, b: PartialState): ConfigState {
  return { ...a, ...b, allauth: { ...a.allauth, ...b.allauth } };
}

interface ConfigStore extends ConfigState {
  setConfig: (state: PartialState) => void;
}

export const useConfigStore = create<ConfigStore>()(
  devtools(
    (set) => ({
      ...default_config,
      loaded: false,
      setConfig: (config) => set((state) => mergeState(state, config)),
    }),
    { name: 'config', enabled: process.env.NODE_ENV !== 'test' },
  ),
);

export default useConfigStore;
